import { render } from "./SellingPolicy.vue?vue&type=template&id=4b5fa756"
import script from "./SellingPolicy.vue?vue&type=script&lang=js"
export * from "./SellingPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__